import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
// import getLocation from '../services/location';
import { StoreList } from "../components/lists/StoreList";
import Loading from "../components/Loading";

// import { Alert } from '@mui/material';
import { useDispatch } from "react-redux";
import { inStore } from "../services/actions";
import { test_ip } from "../services/constants";
import { setError } from "../services/actions";

import { check_error_code } from "../services/error_string";

function Delivery(props) {
  const params = useParams();
  // const [lat, setLat] = useState(null);
  // const [lon, setLon] = useState(null);
  const [loading, setLoading] = useState(true);

  const [stores, setStores] = useState([]);
  const [filter, setFilter] = useState([]);
  const [city_name, setCity_name] = useState("");
  const city_id = localStorage.getItem("city_id");
  const cittty = useLocation().state.name;
  const diapach = useDispatch();
  // var temp = null

  useEffect(() => {
    var lat, lon;
    const UserLocation = JSON.parse(localStorage.getItem("userLocation"));
    if (UserLocation && UserLocation.latitude && UserLocation.longitude) {
      lat = UserLocation.latitude;
      lon = UserLocation.longitude;
    } else {
      //if no loaction pin at dumbel
      lat = 8.9992759;
      lon = 38.7694349;
    }

    // setLat(lat);
    // setLon(lon);
    // setLat()
    //   setLon(data.lon)
    var req_data = {
      city_id: city_id,
      delivery_id: params.id,
      longitude: lon,
      latitude: lat,
    };
    diapach(inStore(req_data));
    Get_Company_list(req_data);
    // getLocation((data) => {
    //   setLat(data.lat)
    //   setLon(data.lon)
    //   var req_data = {
    //     city_id: city_id,
    //     delivery_id: params.id,
    //     longitude: lon,
    //     latitude: lat
    //   }
    //   diapach(inStore(req_data))
    //   Get_Company_list(req_data)
    // });
  }, []);
  var Get_Company_list = function (data) {
    // per delivery type
    var body = {
      city_id: data.city_id,
      store_delivery_id: data.delivery_id,
      longitude: data.longitude,
      latitude: data.latitude,
    };
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/get_company_list`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success == true) {
            let stores = res.data.stores;
            setStores(stores); // all store companies in a single delivery type
            setLoading(false);
            setFilter(stores);
            setCity_name(res.data.city_name);
          } else {
            // console.log(res.data.error_code)
            var message = check_error_code(res.data.error_code);
            diapach(setError({ error: true, message: message }));
          }
        } else {
          // do something
          diapach(
            setError({
              error: true,
              message: "failed to fetch stores,please reload",
            })
          );
        }
      })
      .catch((err) => {
        // do something
        diapach(
          setError({
            error: true,
            message: "failed to fetch stores,please reload",
          })
        );
      });
  };
  const searchStore = useCallback(
    (event) => {
      var fil = event.target.value;
      fil = fil.toLowerCase();
      setFilter(
        stores.filter((store) => {
          return store.name.toLowerCase().includes(fil);
        })
      );
    },
    [stores]
  );
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {" "}
        <Loading></Loading>
      </div>
    );
  } else {
    return (
      <div className="delivery_container">
        <div
          style={{
            backgroundColor: "white",
            marginTop: "5px",
            marginBottom: "5px",
            padding: "8px",
            fontSize: "0.8rem",
          }}
        >
          <h3 style={{ fontSize: "1.2rem" }}>{cittty}</h3>
          <div style={{ fontSize: "0.6rem" }}>
            displaying {stores.length} different stores in your area
          </div>
          <input
            type="text"
            onChange={searchStore}
            style={{
              padding: "5px",
              marginTop: "5px",
              fontSize: "0.6rem",
              width: "50%",
            }}
            placeholder="Type a product name"
          />
        </div>

        <StoreList list={filter} delivery_id={params.id} />
      </div>
    );
  }
}

export default Delivery;
